import Slider from './Slider';
import initGA from './GoogleAnalytics';
import initSectionTabmenu from './SectionTabMenu';
import initClosableElms from './ClosableElements';
import initTabs from './Tabs';
import initPlayer from './Player';
import initInvolvedWebs from './InvolvedWebs';

initSectionTabmenu();
initGA();
initClosableElms();
initTabs();
initPlayer();
initInvolvedWebs();

// eslint-disable-next-line no-new
new Slider('.Slider');
